import React from 'react';
import styled from 'styled-components';

interface InputProps {
  label?: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
}

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  width: 100%;
`;

const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #343a40;
  
  @media (max-width: 768px) {
    font-size: 0.8125rem;
  }
`;

const StyledInput = styled.input<{ hasError?: boolean }>`
  padding: 0.75rem;
  font-size: 1rem;
  border: 2px solid ${props => props.hasError ? '#dc3545' : '#dee2e6'};
  border-radius: 8px;
  outline: none;
  transition: all 0.2s ease;
  
  @media (max-width: 768px) {
    padding: 0.875rem;
    font-size: 1rem;
  }
  
  &:focus {
    border-color: ${props => props.hasError ? '#dc3545' : '#000000'};
    box-shadow: 0 0 0 3px ${props => props.hasError ? 'rgba(220, 53, 69, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
  }
  
  &:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
  }
  
  &::placeholder {
    color: #adb5bd;
  }
`;

const ErrorMessage = styled.span`
  font-size: 0.75rem;
  color: #dc3545;
  margin-top: -0.25rem;
`;

const Input: React.FC<InputProps> = ({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  error,
}) => {
  return (
    <InputWrapper>
      {label && <Label>{label} {required && <span style={{ color: '#dc3545' }}>*</span>}</Label>}
      <StyledInput
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        hasError={!!error}
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
};

export default Input;

